import { connect } from 'react-redux'
import SchoolData from './school-data'
import { getFetchSchoolDataRequest } from '../../../../stores/school-data/school-data.selectors'
import { fetchSchoolData } from '../../../../stores/school-data/school-data.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const fetchRequest = getFetchSchoolDataRequest(state)
  return {
    pending: fetchRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => dispatch(fetchSchoolData()).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SchoolData)
